import type { MantineColorsTuple } from '@mantine/core';

/** Mantine requires _exactly_ 10 colors so */
const padArrayToTen = (
  input: string[],
  filler: string = '#000'
): MantineColorsTuple => {
  const shade = (index: number): string => input[index] ?? filler;
  return [
    shade(0),
    shade(1),
    shade(2),
    shade(3),
    shade(4),
    shade(5),
    shade(6),
    shade(7),
    shade(8),
    shade(9),
  ];
};

export const palette = {
  grayBrand: [
    '#F7F7F7',
    '#F1F1F1',
    '#E7E7E7',
    '#C9C9C9',
    '#B8B8B8',
    '#909090',
    '#6D6D6D',
    '#4D4D4D',
    '#2E2E2E',
    '#1D1C1C',
  ],
  blueBrand: [
    '#EBF5FF',
    '#B4D8FB',
    '#81BEF6',
    '#57A7F2',
    '#3594ED',
    '#1D7AD2',
    '#0E65B7',
    '#05539C',
    '#014381',
    '#003566',
  ],
  redBrand: [
    '#FFEBEB',
    '#F8B2B2',
    '#F17F7F',
    '#EA5454',
    '#E33333',
    '#DC1B1A',
    '#C50D0C',
    '#AE0504',
    '#970101',
    '#800000',
  ],
  greenBrand: [
    '#EBFFF1',
    '#A7E0B8',
    '#70C188',
    '#47A262',
    '#2E964D',
    '#1C8B3D',
    '#107F31',
    '#087328',
    '#036821',
    '#005C1C',
  ],
  tealBrand: [
    '#EBFFFB',
    '#AFECDF',
    '#7CDAC5',
    '#55C7AE',
    '#38B499',
    '#25A187',
    '#198F75',
    '#117C65',
    '#066450',
    '#004D3C',
  ],
  yellowBrand: [
    '#FFF9EB',
    '#FFEBBB',
    '#FFDE8D',
    '#FFD266',
    '#FFC846',
    '#FDBF2E',
    '#F3B21A',
    '#DC9E0C',
    '#B27E04',
    '#8C6200',
  ],
  orangeBrand: [
    '#FFF3EB',
    '#FFD7BA',
    '#FEBC8C',
    '#FEA565',
    '#FD9345',
    '#FD852E',
    '#E26D19',
    '#C75A0B',
    '#AC4A04',
    '#913D00',
  ],
  surface: [
    '#FFFFFF',
    '#F8FCFB',
    '#F3F7F6',
    '#F1F5F4',
    '#ECF0EF',
    '#E7EBEA',
    '#E2E5E5',
    '#DADEDD',
    '#CFD7D5',
    '#C4CFCC',
  ],
  purpleBrand: padArrayToTen(['#6200CA']),
  onSurface: padArrayToTen(['#191A19', '#4F5F5B']),
  outlineColor: padArrayToTen(['#76928B', '#B8CBC6']),
  custom: padArrayToTen([
    '#CCCCCC',
    '#31E2BC', //tealLighten30 for help tooltip link
  ]),
} satisfies Record<string, MantineColorsTuple>;
